export default __webpack_public_path__ + "static/media/heading.f72614a0.svg";